import { httpClient } from "../utils";

export const productService = {
    getProductsOfPublicShop
};

function getProductsOfPublicShop(shop_id = 0) {
    return httpClient.callApi("GET", `/product/getProductsOfPublicShop?shop_id=${shop_id}`, {}, false);
}